/*
 * Public API Surface of ngx-lib/image
 */
export * from './image.module';
export * from './image.component';
